import { useTranslation } from "react-i18next";
import { getPinLevelContentName } from "../../constants/pin-level-codes";
import defaultContent from "../../../content/awardLabels";
import { PIN_LEVEL_CODE } from "../../enums/pin-level-codes";
import { useNoDataAvailableLabel } from "../../hooks/useNoDataAvailableLabel";

type Props = {
  pinLevelCode: PIN_LEVEL_CODE | number;
  isChinaAbo?: boolean;
  shouldMapGarLevelToNonGar?: boolean;
};

export const mapGarLevelToNonGar = (garAwardLevel: PIN_LEVEL_CODE): PIN_LEVEL_CODE => {
  const garPinMapping: { [key: number]: number } = {
    [PIN_LEVEL_CODE.GAR_EXECUTIVE_DIAMOND]: PIN_LEVEL_CODE.EXECUTIVE_DIAMOND,
    [PIN_LEVEL_CODE.GAR_FOUNDERS_EXECUTIVE_DIAMOND]: PIN_LEVEL_CODE.FOUNDERS_EXECUTIVE_DIAMOND,
    [PIN_LEVEL_CODE.GAR_DOUBLE_DIAMOND]: PIN_LEVEL_CODE.DOUBLE_DIAMOND,
    [PIN_LEVEL_CODE.GAR_FOUNDERS_DOUBLE_DIAMOND]: PIN_LEVEL_CODE.FOUNDERS_DOUBLE_DIAMOND,
    [PIN_LEVEL_CODE.GAR_TRIPLE_DIAMOND]: PIN_LEVEL_CODE.TRIPLE_DIAMOND,
    [PIN_LEVEL_CODE.GAR_FOUNDERS_TRIPLE_DIAMOND]: PIN_LEVEL_CODE.FOUNDERS_TRIPLE_DIAMOND,
    [PIN_LEVEL_CODE.GAR_CROWN]: PIN_LEVEL_CODE.CROWN,
    [PIN_LEVEL_CODE.GAR_FOUNDERS_CROWN]: PIN_LEVEL_CODE.FOUNDERS_CROWN,
    [PIN_LEVEL_CODE.GAR_CROWN_AMBASSADOR]: PIN_LEVEL_CODE.CROWN_AMBASSADOR,
    [PIN_LEVEL_CODE.GAR_FOUNDERS_CROWN_AMBASSADOR]: PIN_LEVEL_CODE.FOUNDERS_CROWN_AMBASSADOR,
  };

  return garPinMapping[garAwardLevel] ?? garAwardLevel;
};

const LeafPinLevelName = ({ pinLevelCode, isChinaAbo = false, shouldMapGarLevelToNonGar = false }: Props) => {
  const { t } = useTranslation(["awardLabels"]);
  const noDataAvailableLabel = useNoDataAvailableLabel();

  if (shouldMapGarLevelToNonGar) {
    pinLevelCode = mapGarLevelToNonGar(pinLevelCode);
  }
  const contentKey = getPinLevelContentName(pinLevelCode, isChinaAbo);
  const noPinLevel = contentKey === "awardLabels.no-pin-level";

  if (!contentKey) {
    return (
      <span data-testid="leafPinLevelName" aria-label={noDataAvailableLabel}>
        <span aria-hidden="true">
          {t("awardLabels.no-pin-level", defaultContent.awardLabels["no-pin-level"] as string)}
        </span>
      </span>
    );
  }
  let defaultContentString = defaultContent;
  for (const keyPart of contentKey.split(".")) {
    defaultContentString = defaultContentString[keyPart];
  }

  return (
    <span
      data-testid="leafPinLevelName"
      {...(noPinLevel
        ? {
            "aria-label": noDataAvailableLabel,
          }
        : {})}
    >
      {noPinLevel ? (
        <span aria-hidden="true">{t(contentKey, defaultContentString) as string}</span>
      ) : (
        (t(contentKey, defaultContentString) as string)
      )}
    </span>
  );
};

export default LeafPinLevelName;
